import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./location_tips_level.js";
//#region src/location_tips_level_helper.ts
var location_tips_level_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(tipsLevel) {
	switch (tipsLevel) {
		case 0: return "No Tips";
		case 1: return "Tipping On";
		case 2: return "Tipping On - Always Prompt";
		case 3: return "Tipping On - Prompt After Payment Method Selected";
	}
}
//#endregion
export { location_tips_level_helper_exports, name };

//# sourceMappingURL=location_tips_level_helper.js.map